import { render, staticRenderFns } from "./actualMsiInfo.vue?vue&type=template&id=9ffb3f00&scoped=true"
import script from "./actualMsiInfo.vue?vue&type=script&lang=js"
export * from "./actualMsiInfo.vue?vue&type=script&lang=js"
import style0 from "./actualMsiInfo.vue?vue&type=style&index=0&id=9ffb3f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffb3f00",
  null
  
)

export default component.exports